const PendingStatus = ({ message = "Processando..." }) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 12px',
        backgroundColor: '#fef9c3',
        color: '#92400e',
        borderRadius: '8px'
    }}>
        ⏳
        <span>{message}</span>
    </div>
);
export default PendingStatus;